import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores'
import i18n from '@/i18n'

const routes = [
  {
    path: '/',
    name: 'start',
    component: () => import('@/views/StartView.vue'),
    meta: { titleKey: 'router.start', requiresAuth: false }
  },
  {
    path: '/console',
    name: 'console',
    component: () => import('@/views/ConsoleView.vue'),
    meta: { titleKey: 'router.console', requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { titleKey: 'router.login', requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  if (to.meta.titleKey) {
    document.title = i18n.global.t(to.meta.titleKey)
  }

  const requiresAuth = to.meta.requiresAuth === true

  if (requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/console')
  } else {
    next()
  }
})

export default router
